<div class="recent-table table-responsive"> 
   <table class="table"> 
     <thead> 
       <tr> 
         <th class="f-light">{{ 'Item' | translate }}</th>
         <th class="f-light">{{ 'Qty' | translate }}</th>
         <th class="f-light">{{ 'Price' | translate }}</th>
         <th class="f-light">{{ 'Status' | translate }}</th>
         <th class="f-light">{{ 'Total Price' | translate }}</th>
       </tr>
     </thead>
     <tbody> 
       <tr> 
         <td>
           <div class="product-content">
             <div class="order-image"><img src="assets/images/dashboard-2/order/sub-product/4.png" alt="t-shirt"></div>
             <div> 
               <h6 class="f-14 mb-0"><a href="order-history.html">{{ 'T-shirt' | translate }}</a></h6><span class="f-light f-12">{{ 'Id : #CFDE-2163' | translate }}</span>
             </div>
           </div>
         </td>
         <td class="f-w-500">{{ 'X1' | translate }}</td>
         <td class="f-w-500">{{ '$56.00' | translate }}</td>
         <td class="f-w-500">
           <div class="recent-status font-success"> 
             <svg class="me-1">
               <use href="assets/svg/icon-sprite.svg#24-hour"> </use>
             </svg>Verified
           </div>
         </td>
         <td class="f-w-500">{{ '$100.00' | translate }}</td>
       </tr>
       <tr> 
         <td>
           <div class="product-content">
             <div class="order-image"><img src="assets/images/dashboard-2/order/sub-product/3.png" alt="t-shirt"></div>
             <div> 
               <h6 class="f-14 mb-0"><a href="order-history.html">{{ 'Pink T-shirt' | translate }}</a></h6><span class="f-light f-12">{{ 'Id : #CFDE-2780' | translate }}</span>
             </div>
           </div>
         </td>
         <td class="f-w-500">{{ 'X2' | translate }}</td>
         <td class="f-w-500">{{ '$156.00' | translate }}</td>
         <td class="f-w-500">
           <div class="recent-status font-danger">
             <svg class="me-1">
               <use href="assets/svg/icon-sprite.svg#24-hour"> </use>
             </svg>Rejected
           </div>
         </td>
         <td class="f-w-500">{{ '$870.00' | translate }}</td>
       </tr>
     </tbody>
   </table>
 </div>